export default __webpack_public_path__ + "static/media/src_img_4.206c2606.png";